<template>
  <div
    v-if="valueMutable"
    class="tender-contact-person">
    <sFormItem
      :label="$t('Common.Initials')"
      :prop="`${propName}name`">
      <sSelect
        :allow-create="type == 'additional'"
        autocomplete
        class="person-name width-100"
        clearable
        data-qa="person-name"
        filterable
        :placeholder="$t('Common.Initials')"
        :value.sync="valueMutable"
        value-key="contactId">
        <template #empty>
          <ToggleHiddenPeople
            v-if="type == 'additional' && peoples && peoples.some(el => el.hidden)"
            class="s-select-dropdown__wrap"
            :hide_people="hide_people"
            :toggle-hidden="toggleHidden"/>
        </template>
        <ToggleHiddenPeople
          v-if="type == 'additional' && peoples && peoples.some(el => el.hidden)"
          :hide_people="hide_people"
          :toggle-hidden="toggleHidden"/>
        <template
          v-for="item in items">
          <sOption
            v-if="!hide_people || !item.hidden"
            :key="`person-${item.contactId}`"
            class="person-option-item "
            :data-qa="`person-${item.contactId}`"
            :disabled="load_hide[item.contactId]"
            :label="item.name"
            :value="item">
            <div
              class="flex-between align-center">
              <div class="option__content">
                <div :class="{'grey--text': item.hidden}">
                  {{ item.name }}
                </div>
                <div class="grey--text h8-text">
                  {{ item.phone }}
                </div>
                <div class="grey--text h8-text">
                  {{ item.email }}
                </div>
              </div>
              <sButton
                v-if="type === 'additional'"
                class="hide-button pa-0"
                :icon="item.hidden ? 'eye' : 'eye-slash'"
                :loading="load_hide[item.contactId]"
                small
                type="text"
                @click.stop="hidePerson(item)"/>
            </div>
          </sOption>
        </template>
      </sSelect>
    </sFormItem>
    <sFormItem
      :label="$t('Common.PhoneNumber')"
      :prop="`${propName}phone`">
      <sInput
        v-if="!editable"
        max_length="50"
        placeholder="+ 380 (––) ––– –– ––"
        :readonly="!editable"
        :value="valueMutable.phone"
        @update="updateProp('phone', $event)"/>
      <CustomMaskedInput
        v-else
        class="person-phone"
        debounce
        mask="\+\380 (11) 111 11 11"
        :message="phone_error"
        :model="valueMutable.phone"
        placeholder="+ 380 (––) ––– –– ––"
        placeholder_char="–"
        @update:model="updateProp('phone', $event)"/>
    </sFormItem>
    <sFormItem
      :label="$t('Common.MailAddress')"
      :prop="`${propName}email`">
      <sInput
        v-if="valueMutable"
        max_length="50"
        :placeholder="$t('Common.MailAddress')"
        :readonly="!editable"
        :value="valueMutable.email"
        @change="updateProp('email', $event)"/>
    </sFormItem>
  </div>
</template>
<script>
import CustomMaskedInput from 'components/common/inputs/CustomMaskedInput.vue'
import ToggleHiddenPeople from 'components/tenders/tender creation/ToggleHiddenPeople.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'TenderContactPersonItem',
  data() {
    return {
      hide_people: true,
      load_hide: {},
      phone_error: '',
    }
  },
  methods: {
    toggleHidden() {
      this.hide_people = !this.hide_people
    },
    hidePerson(item) {
      if (!item.contactId) { return }
      this.$set(this.load_hide, item.contactId, true)
      api.changeAdditionalContactHidingStatus({
        contactId: item.contactId,
        hide: !item.hidden
      })
        .then(res => {
          if (res) {
            const peoples = this.$_.cloneDeep(this.peoples)
            const cloneItem = peoples.find(i => i.contactId === item.contactId)
            cloneItem.hidden = !cloneItem.hidden
            this.$emit('update:peoples', peoples)
          }
        })
        .finally(() => {
          this.$set(this.load_hide, item.contactId, false)
        })
    },
    updateProp(propName, value) {
      const result = this.$_.cloneDeep(this.valueMutable)
      result[propName] = value
      this.valueMutable = result
    }
  },
  computed: {
    valueMutable: {
      get() {
        return this.value || {}
      },
      set(newValue, oldValue) {
        let result = newValue
        if (newValue && typeof newValue != 'object') {
          result = {
            name: newValue,
            email: oldValue && !oldValue?.contactId ? oldValue.email : '',
            phone: oldValue && !oldValue?.contactId ? oldValue.phone : ''
          }
        }
        if (!newValue) {
          result =  {
            contactId: '',
            name: '',
            email: oldValue && !oldValue?.contactId ? oldValue.email : '',
            phone: oldValue && !oldValue?.contactId ? oldValue.phone : ''
          }
        }
        delete result.hidden
        this.$emit('update:value', result)
      }
    },
    items() {
      if (!this.peoples?.length) {
        return []
      }

      return this.peoples.filter(el => {
        let current = el?.contactId == this.value?.contactId
        let additional = !this.chosed?.some(item => item?.contactId == el?.contactId) || current
        let main_person = el?.contactId == this.contactPerson?.contactId

        return additional && !main_person
      })
    }
  },
  components: {
    CustomMaskedInput,
    ToggleHiddenPeople,
  },
  props: {
    value: {
      type: Object
    },
    /**
     * Выбранные доп. контактные сособы тенедера (если будет когда-то множество)
     */
    chosed: {
      type: Array,
      default: () => []
    },
    /**
     * Введна ли новая особа руками
     */
    editable: {
      type: Boolean,
    },
    /**
     * Доступные существующие доп. особы
     */
    peoples: {
      type: Array,
    },
    loading: {
      type: Boolean
    },
    /**
     * тип контактної
     */
    type: {
      type: String,
      default: 'main',
      validator: (val) => ['main', 'additional'].includes(val)
    },
    propName: {
      type: String,
      default: ''
    }
  },
}
</script>
<style scoped lang="scss">
.tender-contact-person {
  display: grid;
  gap: 15px;
  &__pib,
  &__phone,
  &__email {
    width: 100%;
  }
}
</style>
